'use client';
import React, { useState, useEffect, useCallback } from 'react';

const slides = [
{
  id: 1,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f0e0649e-1777286982043.png",
  alt: 'Bhargav Parking hero image — automated multi-level car parking facility'
},
{
  id: 2,
  image: "https://images.unsplash.com/photo-1725544015188-4520acceb8b7",
  alt: 'Bhargav Parking hero option 2 — modern automated parking structure exterior'
},
{
  id: 3,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18cb60589-1786012181584.png",
  alt: 'Drone aerial shot of Bhargav Parking large-scale automated parking installation'
},
{
  id: 4,
  image: "https://images.unsplash.com/photo-1722768851768-9fa80d157d46",
  alt: 'Bhargav Parking stack parking system with cars on elevated platforms'
},
{
  id: 5,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e41fd95a-1786012178776.png",
  alt: 'Bhargav Parking tower parking system — vertical multi-level car storage'
},
{
  id: 6,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_181b1dcdb-1786012180826.png",
  alt: 'Bhargav Parking puzzle parking system — space-efficient automated car stacking'
},
{
  id: 7,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_187891cc7-1785956178082.png",
  alt: 'Bhargav Parking shuttle system — automated car retrieval and storage mechanism'
},
{
  id: 8,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1411debb1-1772301039313.png",
  alt: 'Bhargav Parking rotary parking system — circular automated car parking carousel'
},
{
  id: 9,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a9d53334-1785956178073.png",
  alt: 'Bhargav Parking horizontal circulation system — automated lateral car movement'
},
{
  id: 10,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_12e82b3e5-1785956177359.png",
  alt: 'Bhargav Parking commercial project — automated parking installed at commercial complex'
},
{
  id: 11,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_12e82b3e5-1785956177359.png",
  alt: 'Bhargav Parking hospital project — automated parking solution at hospital premises'
},
{
  id: 12,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_12e82b3e5-1785956177359.png",
  alt: 'Bhargav Parking completed project — full installation view of automated parking system'
},
{
  id: 13,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_19b430ca1-1786012179294.png",
  alt: 'Bhargav Parking manufacturing facility — production floor of parking system components'
},
{
  id: 14,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_167d364d9-1785047880517.png",
  alt: 'Bhargav Parking welding process — skilled workers fabricating steel parking structures'
},
{
  id: 15,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a87d7b0b-1768855842475.png",
  alt: 'Bhargav Parking factory floor — manufacturing and assembly of automated parking systems'
},
{
  id: 16,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_15b42a537-1786012179261.png",
  alt: 'Bhargav Parking close-up detail — precision engineering of parking system components'
}];


const slideContent = [
{
  headline: 'Solutions Built\nwith Proof',
  tagline: 'Real installations delivering\nefficiency across sectors'
},
{
  headline: 'Smart Parking\nfor Modern India',
  tagline: 'Technology-driven automated systems\ndesigned and built end-to-end'
},
{
  headline: 'Maximise Space,\nMinimise Effort',
  tagline: 'Multi-level automated parking\ntailored to every project'
},
{
  headline: 'Engineered for\nEvery Scale',
  tagline: 'From residential to commercial\nwe deliver complete solutions'
},
{
  headline: 'You Drive.\nWe Park.',
  tagline: 'Trusted by leading developers\nacross India'
}];


export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const handleCtaClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.getElementById('projects');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const content = slideContent[current % slideContent.length];

  return (
    <section
      id="home"
      className="relative w-full overflow-hidden"
      style={{ height: '100vh', minHeight: '560px' }}>

      {/* Background Slides */}
      {slides.map((slide, i) =>
      <div
        key={slide.id}
        className="absolute inset-0 transition-opacity duration-1000"
        style={{ opacity: i === current ? 1 : 0, zIndex: i === current ? 1 : 0 }}>
          <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url('${slide.image}')` }}
          role="img"
          aria-label={slide.alt} />
        </div>
      )}

      {/* Dark blue gradient overlay — strong on left, fades to transparent on right */}
      <div
        className="absolute inset-0 z-10"
        style={{
          background: 'linear-gradient(to right, rgba(5,28,60,0.92) 0%, rgba(5,28,60,0.75) 35%, rgba(5,28,60,0.35) 65%, rgba(5,28,60,0.05) 100%)'
        }} />

      {/* Bottom gradient for readability */}
      <div
        className="absolute inset-0 z-10"
        style={{
          background: 'linear-gradient(to top, rgba(5,28,60,0.5) 0%, transparent 40%)'
        }} />

      {/* Bottom-left Content */}
      <div className="absolute z-20 flex flex-col items-start" style={{ bottom: '100px', left: 'clamp(32px, 6vw, 80px)', maxWidth: '520px' }}>
        <h1
          className="text-white font-bold mb-4 whitespace-pre-line"
          style={{
            fontFamily: 'Ubuntu, sans-serif',
            fontSize: 'clamp(36px, 5.5vw, 64px)',
            lineHeight: 1.12,
            letterSpacing: '-0.5px',
            textShadow: '0 2px 16px rgba(0,0,0,0.3)'
          }}>
          {content.headline}
        </h1>

        <p
          className="text-white/80 mb-8 whitespace-pre-line"
          style={{
            fontFamily: 'Ubuntu, sans-serif',
            fontSize: 'clamp(14px, 1.6vw, 18px)',
            lineHeight: 1.6
          }}>
          {content.tagline}
        </p>

        <a
          href="#projects"
          onClick={handleCtaClick}
          className="inline-block font-semibold transition-all duration-300 hover:bg-gray-100"
          style={{
            fontFamily: 'Ubuntu, sans-serif',
            fontSize: '15px',
            background: '#ffffff',
            color: '#051c3c',
            padding: '13px 32px',
            letterSpacing: '0.3px'
          }}>
          See Projects
        </a>
      </div>

      {/* Left / Right Arrow Navigation — bottom-left */}
      <div
        className="absolute z-20 flex items-center gap-4"
        style={{ bottom: '40px', left: 'clamp(32px, 6vw, 80px)' }}>
        <button
          onClick={prev}
          aria-label="Previous slide"
          className="flex items-center justify-center transition-all duration-200 hover:bg-white/20"
          style={{
            width: '40px',
            height: '40px',
            border: '1.5px solid rgba(255,255,255,0.7)',
            background: 'transparent',
            color: 'white',
            cursor: 'pointer'
          }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <button
          onClick={next}
          aria-label="Next slide"
          className="flex items-center justify-center transition-all duration-200 hover:bg-white/20"
          style={{
            width: '40px',
            height: '40px',
            border: '1.5px solid rgba(255,255,255,0.7)',
            background: 'transparent',
            color: 'white',
            cursor: 'pointer'
          }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </section>);

}